export default function Hero() {
  const scrollToSection = (id: string) => {
    try {
      const element = document.getElementById(id);
      if (!element) return;
      const offset = 70;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    } catch (error) {
      console.error('Error scrolling to section:', error);
    }
  };

  return (
    <section className="relative md:h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_87df7f4c2ae593f77ef2c11790aa8e6d_1501a27f.jpg"
          alt="McALLISTER DELIGHT Logistics Facility"
          title="Modern logistics center McALLISTER DELIGHT"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/65"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-6 lg:px-12 w-full pt-24 pb-10 md:py-0">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/30 rounded-full px-3 py-1.5 md:px-4 md:py-2 mb-4 md:mb-8">
            <span className="text-lg md:text-2xl">🍁</span>
            <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">
              Canadian Quality
            </span>
          </div>

          {/* Heading */}
          <h1
            className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-3 md:mb-6"
            style={{ letterSpacing: '-0.5px' }}
          >
            Reliable Delivery<br />
            of Fresh Products<br />
            Across Canada
          </h1>

          {/* Subtitle */}
          <p className="text-sm sm:text-lg md:text-xl text-gray-200 leading-relaxed mb-5 md:mb-10 max-w-2xl">
            Professional solutions for food transportation and storage with full temperature control
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-2.5 md:gap-4">
            <button
              onClick={() => scrollToSection('services')}
              className="bg-[#DC2626] text-white px-6 py-3 md:px-8 md:py-4 rounded-xl text-sm md:text-base font-semibold hover:bg-[#B91C1C] transition-all duration-300 flex items-center justify-center space-x-2 whitespace-nowrap"
            >
              <span>Our Services</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </button>

            <button
              onClick={() => scrollToSection('contact')}
              className="bg-transparent border-2 border-white text-white px-6 py-3 md:px-8 md:py-4 rounded-xl text-sm md:text-base font-semibold hover:bg-white hover:text-[#1A365D] transition-all duration-300 whitespace-nowrap text-center"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
